import type { DashboardConfigType } from '@atlassian/jira-dashboard-common/src/types.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (id: string) => fetchJson<DashboardConfigType>(`/rest/dashboards/1.0/${id}.json`);

export const getDashboardsConfig = (idsCsv: string) =>
	fetchJson<DashboardConfigType[]>(`/rest/dashboards/1.0?dashboardId=${idsCsv}`);
